import {FieldConfig, FieldDataTypes, ModelInterface, ModelStatus, uNumber, Uuid} from "@hidat/huijs-common";
import {
  NestUpdateTrackingResource,
  RailsUpdateTrackingResource,
  ResourceConfig,
  ResourceSystemFields,
  UserTrackingResource
} from "@hidat/huijs-resource";

/**
 * Base interface for Splixer resource interfaces
 */
export interface RblResourceInterface<idT extends number | Uuid> extends ModelInterface, RailsUpdateTrackingResource, UserTrackingResource {
  id: idT | undefined;
}

export interface HasBinResource {
  binId: uNumber;
}

export interface RblTenantResourceInterface extends RblResourceInterface<number> {
  tenantId: Uuid | undefined;
  status: ModelStatus | undefined | null;
}

export interface RblNestResourceInterface extends RblResourceInterface<Uuid>, NestUpdateTrackingResource {
  tenantId: Uuid | undefined;
  status: ModelStatus | undefined | null;
}

export const RblFieldConfigs = {
  // System Fields
  id: ResourceSystemFields.intId,
  uid: new FieldConfig('uid', FieldDataTypes.UID).setEditable(false),
  createdAt: ResourceSystemFields.createdAt,
  createdById: ResourceSystemFields.createdBy,
  updatedAt: ResourceSystemFields.updatedAt,
  updatedCount: ResourceSystemFields.updatedCount,
  deletedAt: ResourceSystemFields.deletedAt,
  deletedById: ResourceSystemFields.deletedBy,
  status: ResourceSystemFields.status,

  // Common Attributes
  name: ResourceSystemFields.name,

  // Foreign Keys
  bin: new FieldConfig('binId', FieldDataTypes.NUMBER),
  changeSet: new FieldConfig('changeSetId', FieldDataTypes.NUMBER).setEditable(false),
  changeSetItem: new FieldConfig('changeSetItemId', FieldDataTypes.NUMBER).setEditable(false),
  list: new FieldConfig('listId', FieldDataTypes.NUMBER).setEditable(false),
  listItem: new FieldConfig('listItemId', FieldDataTypes.NUMBER).setEditable(false),
  library: new FieldConfig('libraryId', FieldDataTypes.NUMBER).setEditable(false),
  libraryItem: new FieldConfig('libraryItemId', FieldDataTypes.NUMBER).setEditable(false),
  libraryTitle: new FieldConfig('libraryTitleId', FieldDataTypes.NUMBER).setEditable(false),
  title: new FieldConfig('titleId', FieldDataTypes.NUMBER).setEditable(false),
  repository: new FieldConfig('repositoryId', FieldDataTypes.NUMBER).setEditable(false),
  repoAssetId: new FieldConfig('repoAssetId', FieldDataTypes.NUMBER).setEditable(false),
  job: new FieldConfig('jobId', FieldDataTypes.NUMBER).setEditable(false),
  mediaProcessor: new FieldConfig('mediaProcessorId', FieldDataTypes.NUMBER).setEditable(false),
  mediaItem: new FieldConfig('mediaItemId', FieldDataTypes.NUMBER).setEditable(false),

}

export const RblBaseFieldConfigs = [
  RblFieldConfigs.id, RblFieldConfigs.uid, RblFieldConfigs.createdAt, RblFieldConfigs.createdById, RblFieldConfigs.updatedAt,
  RblFieldConfigs.deletedAt, RblFieldConfigs.deletedById, RblFieldConfigs.status
]

// Used by the Resource Info Component for displaying system info
export const RblResourceInfoConfig = new ResourceConfig('RblResourceInfo').addFields(RblBaseFieldConfigs);

export const RblIncludes = {
  library: 'library',
  catalog: 'catalog',
  libraryItem: 'library_item',
  libraryTitle: 'library_title',
  list: 'list',
  listItem: 'list_item',
  bin: 'bin',
  content: 'content'
}
